export default [
  { brand: "Clarins", key: "Fjd8A03fXz4GrSmgk9E3to" },
  { brand: "Hourglass", key: "9FksnHozv0Fp3SdmlEriskG8" },
  { brand: "DCash", key: "8GhjfSepLreiZa239HfrkSopN" },
  { brand: "KIS", key: "M0skFu3SaVB0nDal9DkQsC" },
  { brand: "Seasun", key: "9Gfk2AkAl0BnsXloG0hErlF9s" },
  { brand: "Nissin", key: "EdkG0sz2Csk0Gk4aAi3Vn3R4" },
  { brand: "Mille", key: "g90Gsm3AlmVe0Te3RewFlso" },
  { brand: "Jewellista", key: "nB9d32Gk0NlaRwqmSpk8gGD" },
  { brand: "SilomEdge", key: "oPf0dn2A9xF0gfnV8dk2ReGk" },
  { brand: "AloThailand", key: "RoG9smCn29RaFl0BmfX9vFk" },
  { brand: "CentralBeauty", key: "9Gsk3WxAkhoH9r3TreSkfAlw" },
  { brand: "Huapla", key: "Ufn39SAlaksVmsD9Go3Ewoq" },
  { brand: "SnakeBrand", key: "0So2FmBkEwaVkk9dsGkoEp" },
  { brand: "Lolane", key: "G8djAm39FpHjErlA0bm2Ao" },
  { brand: "KCInterFoods", key: "WqmF8E03RlHoMkFd2WAox" },
  { brand: "YugenThailand", key: "m9Gk2Alp0qwFxmv9eHgju9X" },
  { brand: "Yongcharoen", key: "lg0Fm2QmzkFbX8qWGloD9sz" },
  { brand: "BanilaCo", key: "C8djs2A0GmfkAw2kG8fj0Go" },
  { brand: "GMHealthCheck", key: "F92MqloF0ppQjfiV9dk6CznLo" },
  { brand: "Thaniya", key: "X93EwlApqV2G0MxlaWeF9B" },
  { brand: "thaniyagroup", key: "X93EwlApqV2G0MxlaWeF9B" },
  { brand: "fatcat", key: "j8GdkSmzCl0FjE3QwekFoeZ" },
  { brand: "thewhoo", key: "D8cCxS0a23AkCnZlFp0QaksS" },
  { brand: "bdmswellness", key: "KD8eQlSzcmC9doEwkFnErmsD" },
  { brand: "doikham", key: "rS6ajVcCp0DskWq9FMVkcxXZX" },
  { brand: "inne", key: "M9dsAo2jCyRelS0paSm21S5Fx" },
  { brand: "ipst", key: "b8FusQoFm9BpsAXeRmGkd3TH" },
  { brand: "beautybuffet", key: "o9FjAECjSakF9lEpGrVm2EWw" },
  { brand: "costhailand", key: "u7WqVnC9OlFkdsXdNmEkKOpZ" },
  { brand: "orlebarbrownthailand", key: "W8qCmV9FsKeR0aBfM3V92gA" },
  { brand: "merge", key: "E9fkDsmZl0Vdi2Ds90GKvpXew3" },
  { brand: "laderachth", key: "Jg8SmSl02QweXkFd4Ad0VkslAs" },
  { brand: "skinprorx", key: "GSk9BvlS03QeXjdG8dFalF0sTyV" },
  { brand: "pettoville", key: "kF9dWEmbD6QlFpsV9Xz74Bgkd" },
  { brand: "mlbthailand", key: "W1FldsapfASDP45aSD25849AD" },
  { brand: "abhaiherb", key: "ZXqpiuy5MNBVCDaDFHycvbnP" },
  { brand: "exploringclub", key: "HDXkFd4Fld0Jg8SyNBik1V5trw" },
  { brand: "banobagixbillkin", key: "BBG7QX9M2KLP4ZR" },
  { brand: "samyanmitrtown", key: "8Gks0QwElV0GjEwo3Fm9BdX" },
  { brand: "aesop", key: "ASsflopsDFHDFGHas1asdr8raD" },
  { brand: "armani", key: "sDFHDFFld0sT02GhSk9kG9SEv" },
  { brand: "giorgioarmanith", key: "gArs572GhOrAdSDdjdsGre8Yg" },
  { brand: "alosingapore", key: "Tfis502GhOrAdSDdjdsGre8OD" },
  { brand: "calvinklein", key: "MNxkwoeASDFGHJmn7tyue6czR" },
  { brand: "onsingapore", key: "PQmsleRFJKTYUQpl9qzxe3bnW" },
  { brand: "onthailand", key: "TRbglopZXCVBNMas2vbnm4uyT" },
  { brand: "paulsmith", key: "LKajsdHFGRTEYUik1dfgh3qweK" },
  { brand: "polorl", key: "ZXqpwerLMNBVCXas9oiuy5treP" },
  { brand: "tommyhilfiger", key: "TYzxcvbNMJHGFDas0lkjh2wqvL" },
  { brand: "primagold", key: "ABnmsdfQWERTYUlm8plok0zxvS" },
  { brand: "peaksportthailand", key: "REdfvbgTREWQAZx1cvbn8lkjH" },
  { brand: "dcrm6", key: "GHpoiuy5trePBVCXopsDFH8S2" },
  { brand: "ingco", key: "INlm8ploAdTREWSGCg8SfWE" },
  { brand: "labotte", key: "FHyWSGcvFFldvbgT8plokRbnP" },
  { brand: "epic", key: "R4tGnX9qLsVbKp2JmD7cHa" },
  { brand: "hairrise", key: "HR5R2X9PL4MQ8" },
  { brand: "nissincampaign", key: "M03QkFoa2WqMbSl8GjRekG9S" },
  { brand: "smeg", key: "GHplmokNBVCXZAq7rtyu5mnjT" },
  { brand: "balmuda", key: "0wXdbdweT73LTKkVqUyfyAeHH" },
  { brand: "brunellocucinelli", key: "WhSZEun51FvtcH15aiUYcs7Po" },
  { brand: "chupachups", key: "gGh7eNzRG0dR2VuHoePbz9Dv" },
  { brand: "cosid", key: "SXxftNMxuyNqiuJF73SzUr6" },
  { brand: "cpfaqua", key: "Q1jJd7uKmBz3sGCnnElkxUl04E" },
  { brand: "csindonesia", key: "vfJHaTjXLfCd2DPOnaw6v5a2x" },
  { brand: "darkthailand", key: "JZe55EpV1Kb2IYeKvhLflsb" },
  { brand: "goldengooseid", key: "CfjrvsQukL8Pw1nWFY1fePjTLt" },
  { brand: "goldpetshop", key: "Hrzou7PmRZvPgmu5wQgSUU0e" },
  { brand: "lacoste", key: "uHnCz0i49dOCVwLDmTsaO1x" },
  { brand: "mmxu2p", key: "fp8bVcBhH5YnV6qlxTQM77v" },
  { brand: "morakot", key: "bPUilU99iwXsfpuYE1FKuI1xpE" },
  { brand: "petme", key: "HLBOuWHrzr1l6xoR1NPqgh7z" },
  { brand: "subduedsingapore", key: "Ki7bkWaQNQo0xbSL8Emd4Ufw3" },
  { brand: "subduedthailand", key: "y2QeW3tfGMLwzXeoC4i9sCboT" },
  { brand: "vrp", key: "62RumMaQfqslqNU7IqTY2dT" }
];
